import staticConf from './../../conf/static';

export const getFirstAsset = ( imageUrl) => {

    const baseUrl = staticConf.base_url_static[0];
    return baseUrl + imageUrl
}

export const getDynamicLoadBalancedAsset = ( imageUrl, indexImage ) => {
    const countServer = staticConf.length;
    const targetedServer = indexImage % countServer;
    return staticConf[targetedServer] + imageUrl;
}


// WEBPACK FOOTER //
// ./src/utils/url/staticUrl.js